'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _recompose = require('recompose');

var _lodash = require('lodash');

var _events = require('dom-helpers/events');

var _tabbable = require('./utils/tabbable');

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *	Traps the focus around the component's children.
 */
var FocusTrap = (_temp = _class = function (_Component) {
	_inherits(FocusTrap, _Component);

	/**
  *
  */
	function FocusTrap(props) {
		_classCallCheck(this, FocusTrap);

		var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));

		(0, _lodash.bindAll)(_this, 'handleKeyEvent', 'handleFocus');
		return _this;
	}

	/**
  *	Initializes the component.
  */


	/**
  *
  */


	_createClass(FocusTrap, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var children = (0, _reactDom.findDOMNode)(this.refs.children);

			this.shiftPressed = false;
			this.previouslyFocused = document.activeElement;
			this.tabbable = (0, _tabbable2.default)(children);

			if (this.tabbable.length) {
				this.tabbable[0].focus();
			}

			(0, _events.on)(document, 'keydown', this.handleKeyEvent);
			(0, _events.on)(document, 'keyup', this.handleKeyEvent);
		}

		/**
   *	Detaches event handlers and sets the focus back
   *	to the element that triggered the modal.
   */

	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			(0, _events.off)(document, 'keydown', this.handleKeyEvent);
			(0, _events.off)(document, 'keyup', this.handleKeyEvent);

			if (this.previouslyFocused) {
				this.previouslyFocused.focus();
			}
		}

		/**
   *	Stores if the shift key is currently pressed.
   *
   *	@param object event Keyboard event.
   */

	}, {
		key: 'handleKeyEvent',
		value: function handleKeyEvent(event) {
			this.shiftPressed = event.shiftKey;
		}

		/**
   *	Handles focus on the modal, avoiding it beeing
   *	lost out of it.
   *
   *	@param object event Event.
   */

	}, {
		key: 'handleFocus',
		value: function handleFocus() {
			if (!this.tabbable.length) {
				return;
			}

			var index = this.shiftPressed ? this.tabbable.length - 1 : 0;

			this.tabbable[index].focus();
		}

		/**
   *
   */

	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'rea11y-FocusTrap' },
				_react2.default.createElement('div', { onFocus: this.handleFocus, tabIndex: '0' }),
				_react2.default.createElement(
					'div',
					{ className: 'rea11y-FocusTrap-children', ref: 'children' },
					this.props.children
				),
				_react2.default.createElement('div', { onFocus: this.handleFocus, tabIndex: '0' })
			);
		}
	}]);

	return FocusTrap;
}(_react.Component), _class.propTypes = {
	children: _react.PropTypes.any.isRequired
}, _temp);
exports.default = (0, _recompose.pure)(FocusTrap);